import ApiBase from './base/ApiBase'
import { NameIdSlim, NameIdEmailSlim } from '../models/custom-models';

class WorkflowGroupClient extends ApiBase {
    private controllerName = 'WorkflowGroup';

    async Create(context: WorkflowGroupContext, signal?: AbortSignal): Promise<string> {
        return this.PostAsync(`${this.controllerName}`, context, signal)
    }

    async Delete(groupId: string, signal?: AbortSignal): Promise<void> {
        return this.DeleteAsync(`${this.controllerName}/${groupId}`, signal);
    }

    async GetAll(signal?: AbortSignal): Promise<NameIdSlim[]> {
        return this.GetAsync(`${this.controllerName}`, signal);
    }

    async GetSingle(id: string, signal?: AbortSignal): Promise<WorkflowGroupDetail> {
        return this.GetAsync(`${this.controllerName}/${id}`, signal);
    }

    async Update(id: string, context: WorkflowGroupContext, signal?: AbortSignal): Promise<string> {
        return this.PutAsync(`${this.controllerName}/${id}`, context, signal)
    }

    // Workflow Group Management
    async GetRoleOptions(signal?: AbortSignal): Promise<OrganizationRoleOptions> {
        return this.GetAsync(`${this.controllerName}/RoleOptions`, signal)
    }

    async GetAvailableTalent(id: string, signal?: AbortSignal): Promise<NameIdEmailSlim[]> {
        return this.GetAsync(`${this.controllerName}/${id}/AvailableTalent`, signal);
    }

    async AddTalentToGroup(id: string, talentId: string, signal?: AbortSignal): Promise<void> {
        return this.PutAsync(`${this.controllerName}/${id}/Talent/${talentId}`, null, signal)
    }

    async RemoveTalentFromGroup(id: string, talentId: string, signal?: AbortSignal): Promise<void> {
        return this.DeleteAsync(`${this.controllerName}/${id}/Talent/${talentId}`, signal);
    }
}

export enum WorkflowGroupErrors {
    Create = 'Error creating Workflow Group',
    Delete = 'Error deleting Workflow Group',
    GetAll = 'Error loading Workflow Groups',
    GetSingle = 'Error loading Workflow Group',
    Update = 'Error saving Workflow Group',
    // Workflow Group Management
    GetRoleOptions = 'Error loading Role Options',
    GetAvailableTalent = 'Error loading Available Talent',
    AddTalentToGroup = 'Error adding Talent to the Workflow Group',
    RemoveTalentFromGroup = 'Error removing Talent from the Workflow Group'
}

export class OrganizationRoleOptions {
    RoleTemplates: string[] = [];
    SecuredActivities: SecuredActivity[] = [];
}

export interface SecuredActivity {
    Key: string;
    Group: string;
    Name: string;
    Description: string;
    RoleTemplates: string[];
}

export interface WorkflowGroupContext {
    Name: string;
    Description: string;
}

export interface WorkflowGroupDetail {
    Id: string;
    Name: string;
    Description: string;
    Members: NameIdEmailSlim[];

    //addon properties
    modified: boolean;
}


export default WorkflowGroupClient